// import { useToast } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { CustomToast } from '../components/toast/CustomToast';
import UserService from '../utils/UserService';
import { useDispatch } from 'react-redux';
import { setIsAuthenticated } from '../redux-toolkit/reducers/authSlice';
import { setUserInfo } from '../redux-toolkit/reducers/userSlice';
import Logout from '../utils/Logout';

export const useErrorHandler = () => {
  const { addToast } = CustomToast();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { doLogout } = Logout();

  const getErrorMessage = (error) => {
    // Handle network errors
    if (error.isNetworkError) {
      return error.message;
    }

    if (error.response && error.response.data) {
      const { message } = error.response.data;
      if (message) {
        return Array.isArray(message)
          ? message.join(',')
          : message?.message || message;
      }
      return error.response.data;
    }
    if (error.response) {
      return error.response.statusText || 'Error occurred';
    }
    return error.message;
  };

  // handles toast for error. called by default on error
  const handleError = (error) => {
    // Log the error for internal tracking
    console.error('API Error:', error);

    // Handle network errors
    if (error.isNetworkError) {
      addToast({ message: error.message, type: 'error' });
      return;
    }

    if (!error.response) {
      addToast({
        message:
          'Unable to connect to the server. Please check your internet connection.',
        type: 'error',
      });
      return;
    }

    if (error.response?.status === 401) {
      addToast({ message: getErrorMessage(error), type: 'error' });
      doLogout();
    } else {
      addToast({ message: getErrorMessage(error), type: 'error' });
    }
  };

  return { handleError };
};
